@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;
@use '../../styling/transitions.scss' as *;

.NavItemVerticalMini {
  @extend %font-family-primary;

  font-size: 11px;
  display: block;


    svg {
      vertical-align: middle;
      height: 14px;
      width: 14px;
      
      path {
        fill: currentColor !important;
      }
    }

  // The overly complex dance of the width and max-width has to do with the transiton.
  // Without these tweaks, the parent of this element (Sidebar) will snap instead of transitioning.

  a {
    text-decoration: none;
    color: $color-white;
    display: inline-block;
    height: 32px;
    line-height: 32px;
    box-sizing: border-box;
    width: 100%;
    padding: 0 30px 0 40px;
    transition: all $transition-duration ease-in-out;
    white-space: nowrap;
    outline: none;

    .Label {
      transition: all $transition-duration ease-in-out;
      vertical-align: middle;
      display: inline-block;
      padding-left: 1em;
      // Needs a defined value to transition
      max-width: 75px;
      text-decoration: inherit;
    }

    &:hover,
    &:focus {
      text-decoration: underline;
      color: $color-white; // Prevent global link blue
    }
  }

  &.isCollapsed a {
    padding: 0 0 0 32px;

    .Label {
      opacity: 0;
      max-width: 0;
      width: auto;
      padding: 0;
    }
  }

  [aria-current] {
    background: $color-nav-secondary;
  }
}
